/* Bundle rows read their figures from window.IF_BUNDLES (ice-freaks-prices.js). */
window.IF_ROW_PRICES = [
  {price:'26.95', was:'44.95',  each:null},
  {price:'46.95', was:'89.90',  each:'$23.48 each'},
  {price:'61.95', was:'134.85', each:'$20.65 each'}
];
